import GLOBAL_CONST from "../constants/global";

export const getAppMode = () => {
  const origin = window.location.origin;

  if (origin === process.env.REACT_APP_SPONSORSHIP_URL) {
    return GLOBAL_CONST.SPONSORSHIP_MODE;
  }

  if (origin === process.env.REACT_APP_THIRD_PARTY_URL) {
    return GLOBAL_CONST.THIRDPARTY_MODE;
  }

  // Optional: Throw, warn, or fallback
  console.warn("Unrecognized origin. Defaulting to SPONSORSHIP_MODE.");
  return GLOBAL_CONST.SPONSORSHIP_MODE;
};

export const getDisplayName = (firstName, lastName, email) => {
  if (firstName && lastName) {
    return `${lastName}, ${firstName}`;
  } else if (firstName) {
    return firstName;
  } else if (lastName) {
    return lastName;
  } else {
    return email || "";
  }
};
